import { createApp } from 'vue'
import LotFilter from './LotFilter.vue'

function initMapPopupControls() {
    const mapPopup = document.querySelector('aside[data-map-popup]')
    if (!mapPopup) return

    const closeButtons = document.querySelectorAll('[data-map-popup-close]')
    closeButtons.forEach(button => {
        button.addEventListener('click', function() {
            mapPopup.setAttribute('data-expanded', 'false')
            document.querySelector('body').setAttribute('data-modal-expanded', 'false')
        })
    })

    const openButtons = document.querySelectorAll('[data-map-popup-open]')
    openButtons.forEach(button => {
        button.addEventListener('click', function() {
            mapPopup.setAttribute('data-expanded', 'true')
            document.querySelector('body').setAttribute('data-modal-expanded', 'true')
        })
    })
}

document.addEventListener('DOMContentLoaded', function() {
    const lotFilterElement = document.getElementById('lot-filter-app')
    if (lotFilterElement) {
        const app = createApp(LotFilter)
        const vm = app.mount('#lot-filter-app')
        window.lotFilterApp = vm
    }

    initMapPopupControls()
})
